import * as styles from "./SliderTrack.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Slider as BaseSlider } from "@base-ui/react/slider";

import type { SliderTrackProps } from "./Slider.types";

export function SliderTrack({
  className,
  ...props
}: SliderTrackProps): JSX.Element {
  return (
    <BaseSlider.Track
      data-slot="slider-track"
      className={clsx(styles.track, className)}
      {...props}
    />
  );
}
